import React from 'react';
import { TIERS, tierMeta } from '../lib/tiers';

// Small pink icon shown next to a creator's name — click cycles nano → micro → mid → mega → none.
export const TierBadge = ({ tier, editable = true, onCycle, testId = 'tier-badge' }) => {
  const meta = tierMeta(tier);
  const idx = TIERS.findIndex((t) => t.id === tier);

  const cycle = (e) => {
    e.stopPropagation();
    if (!editable) return;
    const next = idx === -1 ? TIERS[0].id : idx === TIERS.length - 1 ? '' : TIERS[idx + 1].id;
    onCycle(next);
  };

  return (
    <button
      type="button"
      onClick={cycle}
      disabled={!editable}
      title={meta ? meta.tip : 'set creator tier'}
      className={`inline-flex items-center justify-center h-5 px-2 rounded-full text-[10px] font-semibold shrink-0 border whitespace-nowrap transition-transform ${
        meta ? 'bg-pink-500 text-white border-pink-500' : 'bg-pink-50 text-pink-300 border-pink-200 border-dashed'
      } ${editable ? 'hover:scale-105 cursor-pointer' : 'cursor-default'}`}
      data-testid={testId}
    >
      {meta ? meta.label : '+ tier'}
    </button>
  );
};

// Row of tier pills used inside edit dialogs / detail cards.
export const TierPicker = ({ tier, onPick, testIdPrefix = 'tier' }) => (
  <div className="flex items-center gap-1.5 flex-wrap">
    {TIERS.map((t) => (
      <button
        key={t.id}
        type="button"
        onClick={() => onPick(tier === t.id ? '' : t.id)}
        title={t.tip}
        className={`h-7 px-2.5 rounded-full text-[11px] font-semibold border ${
          tier === t.id ? 'bg-pink-500 text-white border-pink-500' : 'bg-pink-50 text-pink-600 border-pink-200 hover:border-pink-400'
        }`}
        data-testid={`${testIdPrefix}-${t.id}`}
      >
        {t.label}
      </button>
    ))}
  </div>
);
